import axios from 'axios'

import Vue from 'vue'
import LogRocket from 'logrocket'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  userToken: getSavedState('auth.userToken'),
}


export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_CURRENT_TOKEN(state, newValue) {
    state.userToken = newValue
    saveState('auth.userToken', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.userToken
  },
  getUserProfile(state) {
    return state.currentUser
  },
  getCarrierChoice(state) {
    return state.currentUser ? state.currentUser.CarrierChoice.split(',') : []
  },
  getTimezone(state) {
    return state.currentUser ? state.currentUser.TimeZone : null
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    // Create auth data
    var authData =
      'grant_type=password&username=' + username + '&password=' + password

    return axios
      .post(`token`, authData, {
        headers: {
          Authorization:
            'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1laWQiOiJhYTQ3NWU0Ny1hYTMzLTRiZDktYjBkMS0zNWU0Mjk4NTFjMWMiLCJ1bmlxdWVfbmFtZSI6InRrbkdlbmVyYXRvciIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vYWNjZXNzY29udHJvbHNlcnZpY2UvMjAxMC8wNy9jbGFpbXMvaWRlbnRpdHlwcm92aWRlciI6IkFTUC5ORVQgSWRlbnRpdHkiLCJBc3BOZXQuSWRlbnRpdHkuU2VjdXJpdHlTdGFtcCI6IjBkNzM4ZjZhLTYyMDUtNGM3OS05Y2VkLTE4NDUzZjQ0YjRjMSIsInJvbGUiOiJTdXBlckFkbWluIiwiaXNzIjoiaHR0cHM6Ly8xNzIuMTYuMS4xNDY6NDQzIiwiYXVkIjoiMDk5MTUzYzI2MjUxNDliYzhlY2IzZTg1ZTAzZjAwMjIiLCJleHAiOjE0Mzc2NTIxOTUsIm5iZiI6MTQzNzU2NTc5NX0.qg5FzQf5ab-V-63UuyJW01O4IrYtEungnxDQO2_wcKo',
        },
      })
      .then((response) => {
        const token = response.data
        commit('SET_CURRENT_TOKEN', token.access_token)

        dispatch('validate')
        return token.access_token
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_CURRENT_TOKEN', null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {

    if (!state.userToken) return Promise.resolve(null)

    return axios
      .get(`accounts/profile`)
      .then((response) => {
        const user = response.data.Results[0][0]
        commit('SET_CURRENT_USER', user)

        // This is an example script - don't forget to change it!
        LogRocket.identify(user.Id, {
          name: user.FullName,
          email: null,
          username: user.UserName,
        })
        return user
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_CURRENT_USER', null)
          commit('SET_CURRENT_TOKEN', null)
          Vue.$router.push({ name: 'login' })
        } else {
          console.warn(error)
        }
        return null
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.userToken
    ? 'Bearer ' + state.userToken
    : ''
}
